import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { map } from 'rxjs/operators';
import { ThemeService } from '../../../@fury/services/theme.service';
import { IssueCreateComponent } from '../../pages/issue/issue-create/issue-create.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'fury-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  @Input()
  @HostBinding('class.no-box-shadow')
  hasNavigation: boolean;

  @Output() openSidenav = new EventEmitter();
  @Output() openQuickPanel = new EventEmitter();

  topNavigation$ = this.themeService.config$.pipe(map(config => config.navigation === 'top'));

    constructor(private themeService: ThemeService,
        private dialog: MatDialog) {
  }

  ngOnInit() { }

  createIssue() {
    this.dialog.open(IssueCreateComponent);
  }


}
